import { render, staticRenderFns } from "./CommonDetailsDialog.vue?vue&type=template&id=a77e5c06&scoped=true"
import script from "./CommonDetailsDialog.vue?vue&type=script&lang=js"
export * from "./CommonDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77e5c06",
  null
  
)

export default component.exports